/* eslint-disable no-nested-ternary */
/* eslint-disable camelcase */
/* eslint-disable fp/no-nil */
/* eslint-disable fp/no-unused-expression */
import { useEffect, useState } from 'react'
import jwt_decode from 'jwt-decode'

import axios from 'src/utilities/http-client'
import nil from 'src/utilities/nil'
import { useAuth0 } from '@auth0/auth0-react'
import { useAppDispatch } from 'src/store/hooks'
import {
  boundTreeStatusChanged,
  emailAddressChanged,
  linkedServicesChanged,
  rolesChnaged,
  sessionStatusChanged,
  userIDChanged,
} from 'src/v3/settings/settings.slice'

type BoundTreeStatus = 'subscribed' | 'limited' | 'unsubscribed'

export type SessionInfo = {
  roles: string[]
  emailAddress: string
  linkedServices: string[]
  userId: string
  boundTreeStatus: BoundTreeStatus
}

let useSession = (): SessionInfo | undefined => {
  let [session, setSession] = useState<SessionInfo>()
  let { getAccessTokenSilently, logout, isLoading } = useAuth0()
  let dispatch = useAppDispatch()

  useEffect(() => {
    getAccessTokenSilently().then((token) => {
      if (token) {
        let decoded: any = jwt_decode(token)

        let claimsNamespace = 'studio'

        let roles = decoded[`${claimsNamespace}-roles`]
        let linkedServices = decoded[`${claimsNamespace}-linked-services`]
        let emailAddress = decoded[`${claimsNamespace}-email`]
        let userId = decoded[`${claimsNamespace}-sid`]

        let subscriptionStatus =
          decoded[`${claimsNamespace}-subscription-status`]
        let boundTreeStatus: BoundTreeStatus =
          decoded[`${claimsNamespace}-boundtree-subscription-status`] ??
          'unsubscribed'

        if (
          subscriptionStatus !== 'subscribed' ||
          boundTreeStatus === 'limited'
        ) {
          sessionStorage.setItem('studio_jwt', token)
        }

        if (subscriptionStatus !== 'subscribed') {
          let goToSubscribe = () => {
            logout({
              logoutParams: {
                returnTo: `${import.meta.env.VITE_AUTH0_LOGOUT_REDIRECT_URI}/subscribe`,
              },
            })
            // eslint-disable-next-line fp/no-mutation
            window.location.href = `/subscribe`
          }

          axios
            .get('/api/validate-subscription', {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            })
            .then(goToSubscribe)
            .catch(goToSubscribe)
        }

        if (subscriptionStatus === 'subscribed') {
          let sessionInfo = token
            ? {
                roles: roles ? roles.split(',') : [],
                emailAddress,
                linkedServices: linkedServices ? linkedServices.split(',') : [],
                userId,
                boundTreeStatus,
              }
            : nil
          setSession(sessionInfo)

          dispatch(sessionStatusChanged('fulfilled'))
          dispatch(rolesChnaged(sessionInfo?.roles ?? []))
          dispatch(emailAddressChanged(sessionInfo?.emailAddress ?? ''))
          dispatch(linkedServicesChanged(sessionInfo?.linkedServices ?? []))
          dispatch(userIDChanged(sessionInfo?.userId ?? ''))
          dispatch(
            boundTreeStatusChanged(
              sessionInfo?.boundTreeStatus ?? 'unsubscribed',
            ),
          )
        }
      } else {
        setSession(nil)
      }
    })
  }, [getAccessTokenSilently, isLoading])

  return session
}

export default useSession
